import React from 'react'
import { Text, View } from 'react-native'
import { match } from 'ts-pattern'

import Progress from '@ui-kit/components/Progress'

import SectionCircle from './SectionCircle'
import { progressStyles, sectionColumnStyles, sectionLabelStyles, storyStyles } from './styles'
import type { ProgressProps } from './types'

const FlowProgress = (props: ProgressProps) => {
  const { items } = props

  if (items.length === 0) {
    return null
  }

  const { sectionsRow, progressBar, storiesRow, story } = progressStyles({
    showMobileStories: props.showMobileStories,
  })
  const getPosition = (index: number, count: number) =>
    match(index)
      .when(
        () => props.centerLabels,
        () => 'middle' as const
      )
      .with(0, () => 'first' as const)
      .with(count - 1, () => 'last' as const)
      .otherwise(() => 'middle' as const)
  const getState = (item: (typeof items)[number]) =>
    match({ isActive: item.isActive, isCompleted: item.isCompleted })
      .with({ isCompleted: true }, () => 'completed' as const)
      .with({ isActive: true }, () => 'active' as const)
      .otherwise(() => 'future' as const)

  return (
    <>
      {props.showMobileStories && (
        <View className={storiesRow()}>
          {items.map((item) => {
            const { bar, label } = storyStyles({ state: getState(item) })
            return (
              <View key={`progress_story_${item.sectionNumber}`} className={story()}>
                <View className={bar()} />
                <Text className={label()}>{item.label}</Text>
              </View>
            )
          })}
        </View>
      )}
      <View className={sectionsRow()}>
        {items.map((item, i, arr) => {
          const progress = item.progress
          const state = getState(item)

          return (
            <React.Fragment key={`progress_step_${i.toString()}`}>
              <View className={sectionColumnStyles()}>
                <SectionCircle sectionNumber={item.sectionNumber} state={state} />
                <Text
                  className={sectionLabelStyles({ position: getPosition(i, arr.length), state })}
                >
                  {item.label}
                </Text>
              </View>
              {i !== arr.length - 1 && (
                <View className={progressBar()}>
                  <Progress value={progress} />
                </View>
              )}
            </React.Fragment>
          )
        })}
      </View>
    </>
  )
}

export { FlowProgress }
export type { ProgressItem, ProgressProps } from './types'
